<template>
  <div class="exam-page">
    <TopBar pageTitle="答题详情" />

    <div class="exam-body" v-if="examInfo">
      <!-- 成绩概览 -->
      <div class="score-hero" :class="scoreLevel">
        <div class="score-main">
          <p class="score-label">考试成绩</p>
          <p class="score-value">
            <span class="num">{{ showScore ? examInfo.score : '--' }}</span>
            <span class="unit" v-if="showScore">分</span>
          </p>
        </div>
        <div class="score-stats">
          <div class="stat-item">
            <span class="stat-num correct">{{ correctCount }}</span>
            <span class="stat-label">答对</span>
          </div>
          <div class="stat-line"></div>
          <div class="stat-item">
            <span class="stat-num wrong">{{ wrongCount }}</span>
            <span class="stat-label">答错</span>
          </div>
          <div class="stat-line"></div>
          <div class="stat-item">
            <span class="stat-num total">{{ questionList.length }}</span>
            <span class="stat-label">总题数</span>
          </div>
        </div>
        <div class="score-meta">
          <p><span class="meta-k">开始</span>{{ examInfo.created_at || '--' }}</p>
          <!-- <p><span class="meta-k">结束</span>{{ examInfo.updated_at || '--' }}</p> -->
        </div>
      </div>

      <!-- 题目列表 -->
      <div class="section-head">
        <h2 class="section-title">答题详情</h2>
        <span class="section-badge">共 {{ questionList.length }} 题</span>
      </div>

      <div
        class="question-card"
        v-for="(timu, index) in questionList"
        :key="timu.id || index"
        :class="timu.is_right == 1 ? 'is-correct' : 'is-wrong'"
      >
        <div class="question-head">
          <span class="question-no">{{ index + 1 }}</span>
          <div class="question-main">
            <p class="question-title">{{ timu.title || timu.question }}</p>
            <div class="question-tags">
              <span class="tag type">{{ questionTypeText(timu.type) }}</span>
              <span class="tag mark" v-if="timu.mark != null">{{ timu.mark }}分</span>
            </div>
          </div>
          <span class="result-tag" :class="timu.is_right == 1 ? 'ok' : 'fail'">
            {{ timu.is_right == 1 ? '正确' : '错误' }}
          </span>
        </div>

        <div class="options-list">
          <div
            class="option-item"
            v-for="opt in getSelectOptions(timu)"
            :key="opt.key"
            :class="getOptionClass(timu, opt.key)"
          >
            <span class="option-key">{{ opt.key }}</span>
            <span class="option-text">{{ opt.value }}</span>
            <span class="option-flag user" v-if="isOptionSelected(timu, opt.key)">已选</span>
            <span class="option-flag answer" v-if="isCorrectOption(timu, opt.key) && timu.is_right == 0">正确</span>
          </div>
        </div>

        <div class="question-footer" v-if="timu.is_right == 0">
          <div class="footer-row">
            <span class="footer-k">正确答案</span>
            <span class="footer-v ok">{{ formatAnswer(timu.answer, timu) }}</span>
          </div>
          <div class="footer-row">
            <span class="footer-k">你的答案</span>
            <span class="footer-v fail">{{ formatAnswer(timu.user_answer, timu) || '未作答' }}</span>
          </div>
        </div>
      </div>

      <div class="empty-tip" v-if="questionList.length === 0">暂无答题记录</div>
    </div>

    <div class="exam-loading" v-else>
      <span class="loading-dot"></span>
      加载中...
    </div>
  </div>
</template>

<script>
import TopBar from '@/m/common/topBar.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'm-exam',
  components: {
    TopBar,
  },
  data() {
    return {
      examId: '',
      typeIndex: '',
      examInfo: null,
    };
  },
  computed: {
    questionList() {
      return this.examInfo && Array.isArray(this.examInfo.record)
        ? this.examInfo.record
        : [];
    },
    correctCount() {
      return this.questionList.filter((q) => q.is_right == 1).length;
    },
    wrongCount() {
      return this.questionList.filter((q) => q.is_right == 0).length;
    },
    showScore() {
      if (!this.examInfo) return false;
      return this.examInfo.is_show_score != 0;
    },
    scoreLevel() {
      if (!this.showScore) return 'neutral';
      const score = Number(this.examInfo.score);
      const pass = this.examInfo.exam_info && this.examInfo.exam_info.pass;
      if (pass != null && !isNaN(score) && score >= Number(pass)) return 'pass';
      if (!isNaN(score) && score > 0) return 'warn';
      return 'fail';
    },
  },
  mounted() {
    this.examId = this.$route.query.id;
    this.typeIndex = this.$route.query.type;
    this.getExamInfo();
  },
  methods: {
    ...mapMutations(['ShowTipModal']),
    getExamInfo() {
      const url = this.typeIndex == 1
        ? '/v1/personal/examRecord'
        : '/v1/openClass/examRecord';

      this.$axios
        .post(url, { record_id: this.examId }, { useLog: true })
        .then((res) => {
          if (res.code == 0) {
            this.examInfo = res.data;
          } else {
            this.ShowTipModal({
              text: res.msg,
              fun: () => {
                this.$router.back(-1);
              },
            });
          }
        });
    },
    questionTypeText(type) {
      const map = { 1: '单选题', 2: '多选题', 3: '判断题' };
      return map[type] || '题目';
    },
    getSelectOptions(timu) {
      const sd = timu.selectdata;
      if (Array.isArray(sd)) return sd;
      if (sd && typeof sd === 'object') {
        return Object.keys(sd).map((key) => ({ key, value: sd[key] }));
      }
      return [];
    },
    normalizeAnswer(val, options) {
      if (val == null || val === '') return [];
      if (Array.isArray(val)) return val.map(String);

      const str = String(val).trim();
      const optionKeys = options ? options.map((o) => String(o.key)) : [];

      if (/[,，、\s]/.test(str)) {
        return str.split(/[,，、\s]+/).filter(Boolean);
      }
      if (optionKeys.includes(str)) return [str];
      if (optionKeys.length && str.length > 1) {
        const chars = str.split('');
        if (chars.every((c) => optionKeys.includes(c))) return chars;
      }
      return str ? [str] : [];
    },
    formatAnswer(val, timu) {
      const options = timu ? this.getSelectOptions(timu) : [];
      const arr = this.normalizeAnswer(val, options);
      return arr.length ? arr.join('、') : '';
    },
    isOptionSelected(timu, key) {
      const options = this.getSelectOptions(timu);
      return this.normalizeAnswer(timu.user_answer, options).includes(String(key));
    },
    isCorrectOption(timu, key) {
      const options = this.getSelectOptions(timu);
      return this.normalizeAnswer(timu.answer, options).includes(String(key));
    },
    getOptionClass(timu, key) {
      const selected = this.isOptionSelected(timu, key);
      const correct = this.isCorrectOption(timu, key);
      return {
        'is-selected': selected,
        'is-correct-opt': correct && timu.is_right == 1,
        'is-wrong-opt': selected && timu.is_right == 0 && !correct,
        'is-answer-opt': correct && timu.is_right == 0,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.exam-page {
  min-height: 100vh;
  background: #f5f6f8;
  padding-bottom: 40px;
}

.exam-body {
  padding: 20px 24px 0;
}

/* ── 成绩概览 ── */
.score-hero {
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px 24px;
  box-shadow: 0 4px 24px rgba(0, 12, 40, 0.06);
  margin-bottom: 28px;
  border-top: 6px solid #254ed4;

  &.pass { border-top-color: #52c41a; }
  &.warn { border-top-color: #faad14; }
  &.fail { border-top-color: #ff4d4f; }
  &.neutral { border-top-color: #d9d9d9; }
}

.score-main {
  text-align: center;
  padding-bottom: 28px;
  border-bottom: 1px solid #f0f2f5;
}

.score-label {
  font-size: 24px;
  color: #999;
  margin: 0 0 8px;
}

.score-value {
  margin: 0;
  line-height: 1;

  .num {
    font-size: 72px;
    font-weight: 700;
    color: #254ed4;
  }

  .unit {
    font-size: 28px;
    color: #999;
    margin-left: 4px;
  }
}

.score-hero.pass .score-value .num { color: #389e0d; }
.score-hero.warn .score-value .num { color: #d48806; }
.score-hero.fail .score-value .num { color: #cf1322; }
.score-hero.neutral .score-value .num { color: #8c8c8c; }

.score-stats {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 24px 0;
  border-bottom: 1px solid #f0f2f5;
}

.stat-item {
  text-align: center;
  flex: 1;

  .stat-num {
    display: block;
    font-size: 40px;
    font-weight: 600;
    line-height: 1.2;

    &.correct { color: #52c41a; }
    &.wrong { color: #ff4d4f; }
    &.total { color: #254ed4; }
  }

  .stat-label {
    display: block;
    font-size: 22px;
    color: #999;
    margin-top: 6px;
  }
}

.stat-line {
  width: 1px;
  height: 48px;
  background: #f0f2f5;
}

.score-meta {
  padding-top: 20px;

  p {
    font-size: 22px;
    color: #666;
    line-height: 1.6;
    margin: 0 0 8px;
    word-break: break-all;

    &:last-child { margin-bottom: 0; }
  }

  .meta-k {
    display: inline-block;
    width: 56px;
    color: #999;
    margin-right: 8px;
  }
}

/* ── 题目区 ── */
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 0 4px;
}

.section-title {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0;
}

.section-badge {
  font-size: 22px;
  color: #666;
  background: #eef0f3;
  padding: 6px 16px;
  border-radius: 24px;
}

.question-card {
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 16px rgba(0, 12, 40, 0.05);
  border-left: 6px solid transparent;

  &.is-correct { border-left-color: #52c41a; }
  &.is-wrong { border-left-color: #ff4d4f; }
}

.question-head {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.question-no {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: #254ed4;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  border-radius: 10px;
}

.question-main {
  flex: 1;
  min-width: 0;
}

.question-title {
  font-size: 28px;
  font-weight: 500;
  color: #1a1a2e;
  line-height: 1.55;
  margin: 0 0 12px;
}

.question-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag {
  font-size: 20px;
  padding: 4px 12px;
  border-radius: 6px;

  &.type {
    background: #eef2ff;
    color: #254ed4;
  }

  &.mark {
    background: #f5f5f5;
    color: #888;
  }
}

.result-tag {
  flex-shrink: 0;
  font-size: 22px;
  font-weight: 500;
  padding: 6px 14px;
  border-radius: 8px;

  &.ok {
    background: #f6ffed;
    color: #389e0d;
    border: 1px solid #b7eb8f;
  }

  &.fail {
    background: #fff1f0;
    color: #cf1322;
    border: 1px solid #ffa39e;
  }
}

/* ── 选项 ── */
.options-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 20px;
  border-radius: 12px;
  border: 1px solid #e8eaf0;
  background: #fafbfc;

  &.is-selected {
    border-color: #254ed4;
    background: #eef2ff;
  }

  &.is-correct-opt {
    border-color: #52c41a;
    background: #f6ffed;
  }

  &.is-wrong-opt {
    border-color: #ff4d4f;
    background: #fff1f0;
  }

  &.is-answer-opt {
    border-color: #52c41a;
    background: #f6ffed;
  }
}

.option-key {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #d9d9d9;
  font-size: 22px;
  font-weight: 600;
  color: #666;
}

.is-selected .option-key,
.is-correct-opt .option-key {
  background: #254ed4;
  border-color: #254ed4;
  color: #fff;
}

.is-wrong-opt .option-key {
  background: #ff4d4f;
  border-color: #ff4d4f;
  color: #fff;
}

.is-answer-opt .option-key {
  background: #52c41a;
  border-color: #52c41a;
  color: #fff;
}

.option-text {
  flex: 1;
  font-size: 26px;
  color: #333;
  line-height: 1.5;
}

.option-flag {
  flex-shrink: 0;
  font-size: 20px;
  padding: 4px 12px;
  border-radius: 6px;

  &.user {
    background: #eef2ff;
    color: #254ed4;
  }

  &.answer {
    background: #f6ffed;
    color: #389e0d;
  }
}

.question-footer {
  margin-top: 24px;
  padding: 20px;
  background: #f7f8fa;
  border-radius: 12px;
}

.footer-row {
  display: flex;
  align-items: center;
  font-size: 24px;
  line-height: 1.6;
  margin-bottom: 8px;

  &:last-child { margin-bottom: 0; }
}

.footer-k {
  color: #999;
  margin-right: 12px;
  flex-shrink: 0;
}

.footer-v {
  font-weight: 600;

  &.ok { color: #52c41a; }
  &.fail { color: #ff4d4f; }
}

.empty-tip {
  text-align: center;
  padding: 80px 0;
  font-size: 26px;
  color: #999;
}

.exam-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 120px 0;
  font-size: 26px;
  color: #999;
}

.loading-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #254ed4;
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 0.3; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1); }
}
</style>
